// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uU2O","top":"styles_top__2ZO3e","left":"styles_left__3S_Dn","description":"styles_description__3llvt"};